import React from 'react';
import { Navigate, useParams } from 'react-router';

interface LscLeagueRouteRedirectProps {
  toSegment: string;
}

/** Preserve league id while redirecting legacy alias paths to canonical routes. */
const LscLeagueRouteRedirect: React.FC<LscLeagueRouteRedirectProps> = ({ toSegment }) => {
  const { leagueId, archiveId, candidateId } = useParams<{
    leagueId: string;
    archiveId?: string;
    candidateId?: string;
  }>();

  if (!leagueId) {
    return <Navigate to="/leagues" replace />;
  }

  if (archiveId) {
    return (
      <Navigate
        to={`/leagues/${encodeURIComponent(leagueId)}/${toSegment}/${encodeURIComponent(archiveId)}`}
        replace
      />
    );
  }

  if (candidateId) {
    return (
      <Navigate
        to={`/leagues/${encodeURIComponent(leagueId)}/vods/${encodeURIComponent(candidateId)}`}
        replace
      />
    );
  }

  return <Navigate to={`/leagues/${encodeURIComponent(leagueId)}/${toSegment}`} replace />;
};

export default LscLeagueRouteRedirect;
